var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-lk-success",class:_vm.props.class},[(_vm.props.title)?_c('h3',{staticClass:"t-lk-modal__title t-lk-success__title"},[_vm._v(_vm._s(_vm.props.title))]):_vm._e(),_vm._v(" "),(_vm.props.text)?_c('div',{staticClass:"t-lk-success__text"},[_vm._v(_vm._s(_vm.props.text))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"t-lk-success__btn-error t-btn _green _lk",on:{"click":_vm.modalClose}},[_vm._v("\n    "+_vm._s(_vm.$root.staticText.lk.lkModalBtn)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/lk-error.vue?vue&type=template&id=66ed576e&
// module id = 1678
// module chunks = 0